import { PriceMainProps, ProductPriceViewProps } from 'common/components/product-price-view/types';
import { getPriceParts } from 'utils/price-parts';
import { UOMS } from '../../constants';
import { getCurrencySymbolByCurrency } from 'utils';

export const setProps = ({
  price,
  currency,
  unit,
  prevPrice,
  locale,
  discountPercent,
}: PriceMainProps): ProductPriceViewProps => ({
  ...getPriceParts({ price, currencySlug: currency, locale }),
  unit,
  prevPrice: prevPrice ? prevPrice.toString() : '',
  discountPercent: discountPercent ?? discountPercent,
});

export const isValues = ({ price, currency }: PriceMainProps) => price && currency;

export const getProjectPriceResult = ({
  inBasket,
  quantity,
  mainUom,
  firstPrice,
  secondPrice,
  previousAdditionalPrice,
  configurationArea,
}: {
  inBasket: boolean;
  quantity: number;
  mainUom?: string;
  firstPrice: PriceMainProps;
  secondPrice: PriceMainProps;
  previousAdditionalPrice?: number;
  configurationArea?: number;
}) => {
  let previousPriceBox = null;
  let previousPrice = null;

  const isShowBasketQuantity = inBasket && !!quantity;

  const priceBox = mainUom === UOMS.CAR ? firstPrice.price : secondPrice.price;
  const priceM2 = mainUom === UOMS.M2 ? firstPrice.price : secondPrice.price;

  const areaPerBox = Math.floor((priceBox / priceM2) * 1000) / 1000;
  const amountBox = isShowBasketQuantity ? quantity : Math.ceil((configurationArea as number) / areaPerBox);

  if (firstPrice.prevPrice) {
    previousPriceBox = mainUom === UOMS.CAR ? firstPrice.prevPrice : previousAdditionalPrice;
    previousPrice = Number(previousPriceBox) * amountBox;
  }

  const projectPrice = {
    ...firstPrice,
    price: priceBox * amountBox,
    unit: null,
    ...(previousPrice ? { prevPrice: String(previousPrice) } : {}),
  };

  return {
    projectPrice,
    areaPerBox,
    amountBox,
  };
};

export const calculatePriceType = (
  isBestPrice: boolean,
  prevPrice?: string | null,
  outOfStockPriceDisplayed?: boolean,
) => {
  let type: 'default' | 'discount' | 'best' | 'sold' = 'default';
  if (isBestPrice) {
    type = 'best';
  } else if (prevPrice) {
    type = 'discount';
  }
  if (outOfStockPriceDisplayed) {
    type = 'sold';
  }
  return type;
};

export const concatUnit = (price: PriceMainProps) =>
  `${getCurrencySymbolByCurrency(price.currency)}${price.unit ? `/${price.unit}` : ''}`;

export const ratioToPercent = (discountRatio?: number | null) =>
  discountRatio ? Math.trunc(discountRatio * 100) : undefined;
